/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';

import { useTheme } from 'contexts/ThemeContext';
import { useUser } from 'contexts/UserContext';

import {
  parseCustomLabel,
  serializePlatformAccount,
  serializePlatformPage
} from 'utils/functions';
import pluralize from 'utils/pluralize';
import {
  ACTIVATEDAUDIENCES,
  ACTIVATION,
  CONNEXION,
  CUSTOMERS,
  DATA_PROVIDERS,
  GROUP,
  IMPORTMODEL,
  INSIGHT,
  PROPERTIES
} from 'utils/rest';

import { ButtonCreate } from 'components/ButtonCreate';
import { HelpTooltip, Text, Tooltip } from 'components/DataDisplay';
import { TextField } from 'components/Inputs';
import { Container, Item, Row } from 'components/Layout';
import { Loading } from 'components/Loading';
import { TableData } from 'components/TableData';
import { UnauthorizedModal } from 'components/UnauthorizedModal';

import { ModalDelete } from '../../../components/ModalDelete';

import { ModalForm } from './components/ModalForm';

function GroupContainer() {
  const [config, setConfig] = React.useState({});
  const [rows, setRows] = React.useState([]);
  const [activationPresetsData, setActivationPresetData] = useState();
  const [insightTarget, setInsightTarget] = useState();
  const [importModel, setImportModel] = useState();
  const [connectorsConnexion, setConnectorsConnexion] = useState();
  const [activatedAudiences, setActivatedAudiences] = useState();
  const [properties, setProperties] = useState();
  const [loaded, setLoaded] = React.useState(false);
  const [openModal, setModal] = React.useState(null);
  const [selectedGroup, setSelectedGroup] = React.useState({});
  const { themeColors } = useTheme();
  const { adminRights } = useUser();
  const [dataProviders, setDataProviders] = useState([]);
  const [activableMedias, setActivableMedias] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchFieldValue, setSearchFieldValue] = useState('');

  const closeModal = () => {
    setModal(null);
    setSelectedGroup({});
  };
  const onDelete = () => {
    GROUP.deleteGroup(selectedGroup._id)
      .catch()
      .then(() => {
        setLoaded(false);
        closeModal();
      });
  };

  const normalizeDataProviders = providers => {
    return (
      providers?.map(provider => ({
        key: provider,
        label: provider
      })) || []
    );
  };

  const selectGroup = async id => {
    const group = await GROUP.getGroupRich(id);
    const selected = {
      ...group,
      dataProviders: normalizeDataProviders(group.dataProviders),
      excludeDataProviders: normalizeDataProviders(group.excludeDataProviders)
    };
    if (group?.activableMedias?.length > 0) {
      selected.selectedActivableMedias = group.activableMedias;
    }
    setSelectedGroup(selected);
    return selected;
  };

  const getDataProviders = async () => {
    const response = await DATA_PROVIDERS.get();
    return normalizeDataProviders(response);
  };

  const getGroupsPaginated = async ({
    page = 1,
    limit = 10,
    custom = false,
    withFunnels = false,
    withPreset = false
  }) => {
    try {
      const projection = {
        shopGroupId: 1,
        name: 1,
        activationShopId: 1,
        funnelIds: 1,
        activatedAudiences: 1,
        insightUserTarget: 1,
        activationPresetIds: 1,
        key: 1,
        stripeCustomerId: 1,
        customerId: 1,
        platformAccounts: 1,
        platformPages: 1
      };

      if (withPreset) {
        projection.presetId = 1;
      }

      const result = await GROUP.getGroupSearch({
        page,
        limit,
        search: searchFieldValue,
        custom,
        withFunnels,
        projection
      });
      return result;
    } catch (err) {
      console.error(err);
      return [];
    }
  };

  const getPresets = async () => {
    try {
      const result = await ACTIVATION.getActivationPresets();
      return result;
    } catch (err) {
      console.error(err);
      return [];
    }
  };

  const getInsight = async () => {
    try {
      const result = await INSIGHT.getInsight();
      return result;
    } catch (err) {
      console.error(err);
      return [];
    }
  };

  const getActivatedAudiences = async () => {
    try {
      const result = await ACTIVATEDAUDIENCES.getActivatedAudiences();
      return result;
    } catch (err) {
      console.error(err);
      return [];
    }
  };

  const getToolTipText = txt => {
    return (
      <Row spacing={0}>
        <Item>
          <Text color={themeColors.dark}>{txt}</Text>
        </Item>
      </Row>
    );
  };
  const formatUsers = (usersList = []) => {
    const nbUsers = usersList.length;
    if (nbUsers === 0) {
      return <Text>Aucun</Text>;
    }
    if (nbUsers === 1)
      return <Text color="global"> {usersList[0] && usersList[0].email} </Text>;

    const others = nbUsers - 1;
    const str = ` ${others} ${pluralize('autre', others)} ${pluralize(
      'utilisateur',
      others
    )}`;

    const tooltipContent = () => {
      return (
        <Container>
          {usersList.map(user => getToolTipText(user.email))}
        </Container>
      );
    };
    return (
      <Container>
        <Row spacing={2}>
          <Item flex>
            <Text color="global"> {usersList[0].email}&nbsp;</Text>
          </Item>
          <Item flex>
            <Text> et&nbsp;</Text>
          </Item>
          <Item flex>
            <Tooltip title={tooltipContent()}>
              <Text color="global">{str}</Text>
            </Tooltip>
          </Item>
        </Row>
      </Container>
    );
  };

  const formatFunnels = funnelsList => {
    const nbFunnel = funnelsList.length;

    if (nbFunnel === 0) {
      return <Text>Aucun</Text>;
    }
    const str = `${nbFunnel} ${pluralize('funnel', nbFunnel)}`;

    const tooltipContent = () => {
      return (
        <Container>
          <Row spacing={0}>
            <Item>
              {funnelsList.map(funnel => getToolTipText(funnel.name))}
            </Item>
          </Row>
        </Container>
      );
    };

    return (
      <Container>
        <Row spacing={0}>
          <Item>
            <Tooltip title={tooltipContent()}>
              <Text color="funnel">{str}</Text>
            </Tooltip>
          </Item>
        </Row>
      </Container>
    );
  };

  const formatPlatformAccountsAndPages = (items, type = 'Compte') => {
    if (!Array.isArray(items)) {
      return <Text>{items || 'Aucun'}</Text>;
    }

    const nbItems = items.length;
    if (nbItems === 0) {
      return <Text>Aucun</Text>;
    }

    const str = `${nbItems} ${pluralize(type, nbItems)}`;

    const groupedByMedia = items.reduce((acc, item) => {
      const model = item?.media || item?.model || 'Autre';
      if (!acc[model]) {
        acc[model] = [];
      }
      acc[model].push(item);
      return acc;
    }, {});

    const tooltipContent = () => (
      <Container spacing={0}>
        {Object.entries(groupedByMedia).map(([media, mediaItems]) => (
          <Container>
            <Row spacing={0}>
              <Item>
                <Text fontWeight="bold" color="dark" fontSize={18}>
                  {media}
                </Text>
              </Item>
            </Row>
            {mediaItems.map(item => (
              <Row spacing={0}>
                <Item paddingLeft={2}>
                  <Text color="dark">
                    • {item.config?.externalId || 'sans config'}
                  </Text>
                </Item>
              </Row>
            ))}
          </Container>
        ))}
      </Container>
    );

    return (
      <Container>
        <Row spacing={0}>
          <Item>
            <Tooltip maxWidth="180px" title={tooltipContent()}>
              <Text color="activation">{str}</Text>
            </Tooltip>
          </Item>
        </Row>
      </Container>
    );
  };

  const formatCustomLabel = str => {
    if (!str?.length) {
      return <Text>Aucun</Text>;
    }
    return (
      <Container>
        <Row spacing={0}>
          <Item>
            <HelpTooltip title={str} />
          </Item>
        </Row>
      </Container>
    );
  };

  const formatPreset = preset => {
    if (!preset?._id) {
      return <Text>Aucun</Text>;
    }
    const str = preset?.name || preset._id;

    const tooltipContent = () => {
      return (
        <Container>
          <Row spacing={0}>
            <Item>{getToolTipText(preset._id)}</Item>
          </Row>
        </Container>
      );
    };
    return (
      <Container>
        <Row spacing={0}>
          <Item>
            <Tooltip title={tooltipContent()}>
              <Text color="activation">{str}</Text>
            </Tooltip>
          </Item>
        </Row>
      </Container>
    );
  };

  useEffect(() => {
    const fetchStaticData = async () => {
      const [
        resPreset,
        resInsight,
        resActiAudience,
        propertiesList,
        resImportModel,
        resConnectorsConnexion,
        fetchedProviders,
        allActivableMedias
      ] = await Promise.all([
        getPresets(),
        getInsight(),
        getActivatedAudiences(),
        PROPERTIES.get(),
        IMPORTMODEL.get(),
        CONNEXION.getConnexions(),
        getDataProviders(),
        ACTIVATION.getActivableMedias()
      ]);
      setDataProviders(fetchedProviders);
      setActivableMedias(allActivableMedias);
      setConnectorsConnexion(
        resConnectorsConnexion.map(e => ({
          label: e.name,
          value: e._id
        }))
      );
      setImportModel(
        resImportModel.map(e => ({
          label: e.label,
          value: e.model
        }))
      );

      setActivationPresetData(
        resPreset.map(e => ({ name: e.name, _id: e._id }))
      );

      setInsightTarget(resInsight.map(e => ({ name: e.name, _id: e._id })));

      setActivatedAudiences(
        resActiAudience.map(e => ({ name: e.name, _id: e._id }))
      );

      setProperties(propertiesList);
      setLoaded(true);
    };

    fetchStaticData();
  }, [loaded]);

  useEffect(() => {
    if (!loaded) {
      return;
    }

    const fetchGroups = async () => {
      const resp = await getGroupsPaginated({
        page: pageNumber + 1,
        limit: rowsPerPage,
        custom: true,
        withFunnels: true,
        withPreset: true
      });

      setTotalCount(resp.totalCount);
      const mapped = resp.data.map(item => {
        const formatFunnelsWithProps =
          item?.formattedFunnels?.map(el => {
            const foundProperty = properties.find(prop =>
              prop.funnelIds?.includes(el._id)
            );

            return {
              ...el,
              name: foundProperty
                ? `${foundProperty.name} > ${el.name}`
                : el.name
            };
          }) || [];

        return {
          _id: item._id,
          name: item.name,
          users: formatUsers(item?.formattedUsers || []),
          funnels: formatFunnels(formatFunnelsWithProps || []),
          preset: formatPreset(item.preset),
          platformAccounts: formatPlatformAccountsAndPages(
            item.platformAccounts
          ),
          platformPages: formatPlatformAccountsAndPages(
            item.platformPages,
            'Page'
          ),
          customLabel: formatCustomLabel(parseCustomLabel(item))
        };
      });
      setRows(mapped);
    };

    fetchGroups();
  }, [pageNumber, loaded, rowsPerPage, searchFieldValue]);

  const handleCreateGroup = data => {
    GROUP.create({
      name: data.name,
      presetId: data.presetId,
      userIds: data.selectedUsers.map(e => e._id),
      funnelIds: data.selectedFunnels.map(e => e._id),
      activationPresetIds: data.selectedActivationPresets.map(e => e._id),
      activatedAudiences: data.selectedActivatedAudiences.map(el => el._id),
      platformAccounts: data.selectedPlatformAccounts.map(
        serializePlatformAccount
      ),
      platformPages: data.selectedPlatformPages.map(el =>
        serializePlatformPage(el)
      ),
      accountManagers: data.selectedAccountManagers.map(el => el._id),
      mandats: data.mandats,
      useFunnelDataInActivation: data.useFunnelDataInActivation,
      campaignCrm: {
        active: data.enableCRMCampaign,
        presetId: data.enableCRMCampaign ? data.crmPresetId : ''
      },
      dataProviders: data.dataProviders,
      excludeDataProviders: data.excludeDataProviders,
      copyPal: data.copyPal,
      activableMedias: data.activableMedias,
      activationRequiredMediaConfigs: data.activationRequiredMediaConfigs,
      budgetTypeImpressions:
        data.budgetTypeImpressions === 'domain'
          ? null
          : data.budgetTypeImpressions === 'impressions'
    }).then(() => {
      setModal(null);
      setLoaded(false);
    });
  };

  const handleUpdateGroup = data => {
    GROUP.updateV2(selectedGroup._id, {
      name: data.name !== selectedGroup.name ? data.name : undefined,
      presetId: data.presetId,
      funnelIds: data.selectedFunnels.map(el => el._id),
      userIds: data.selectedUsers.map(el => el._id),
      activationPresetIds: data.selectedActivationPresets.map(el => el._id),
      insightUserTarget: data.selectedInsightTarget.map(el => el._id),
      activatedAudiences: data.selectedActivatedAudiences.map(el => el._id),
      stripeCustomerId: data.stripeCustomerId,
      platformAccounts: data.selectedPlatformAccounts.map(el =>
        serializePlatformAccount(el)
      ),
      platformPages: data.selectedPlatformPages.map(el =>
        serializePlatformPage(el)
      ),
      accountManagers: data.selectedAccountManagers.map(el => el._id),
      mandats: data.mandats,
      useFunnelDataInActivation: data.useFunnelDataInActivation,
      campaignCrm: {
        active: data.enableCRMCampaign,
        presetId: data.enableCRMCampaign ? data.crmPresetId : ''
      },
      dataProviders: data.dataProviders,
      excludeDataProviders: data.excludeDataProviders,
      copyPal: data.copyPal,
      activableMedias: data.activableMedias,
      activationRequiredMediaConfigs: data.activationRequiredMediaConfigs,
      budgetTypeImpressions:
        data.budgetTypeImpressions === 'domain'
          ? null
          : data.budgetTypeImpressions === 'impressions'
    }).then(() => {
      setModal(null);
      setLoaded(false);
    });
  };

  const addGroup = async () => {
    if (adminRights?.general?.groups?.create) {
      const stripeCustomers = await CUSTOMERS.get();

      setConfig({
        properties,
        activationPresets: activationPresetsData,
        insightUserTarget: insightTarget,
        activatedAudiences,
        importModel,
        connectorsConnexion,
        dataProvidersOptions: dataProviders,
        stripeCustomers,
        canEditCustomer: adminRights?.general?.customers?.advanced
      });
      setModal('modalCreate');
    } else {
      setModal('unauthorized');
    }
  };

  const updateGroup = async id => {
    if (adminRights?.general?.groups?.update) {
      const group = await selectGroup(id);
      const stripeCustomers = await CUSTOMERS.get();

      let budgetTypeImpressions;

      if (group.budgetTypeImpressions === true) {
        budgetTypeImpressions = 'impressions';
      } else if (group.budgetTypeImpressions === false) {
        budgetTypeImpressions = 'budget';
      } else {
        budgetTypeImpressions = 'domain';
      }

      setConfig({
        properties,
        id,
        activationPresets: activationPresetsData,
        insightUserTarget: insightTarget,
        activatedAudiences,
        importModel,
        connectorsConnexion,
        stripeCustomers,
        dataProvidersOptions: dataProviders,
        canEditCustomer: adminRights?.general?.customers?.advanced,
        actualState: {
          ...group,
          selectedActivationPresets: group.activationPresetIds.map(e =>
            activationPresetsData.find(f => f._id === e)
          ),
          selectedInsightTarget: group.insightUserTarget.map(e =>
            insightTarget.find(f => f._id === e)
          ),
          selectedActivatedAudiences: group.activatedAudiences.map(e =>
            activatedAudiences.find(f => f._id === e)
          ),
          selectedPlatformPages: group.platformPages?.map(e => {
            const connector = connectorsConnexion.find(
              el => el.value === e.config.connexionId
            );
            return {
              name: e.name,
              media: e.media,
              connexionId: connector
                ? {
                    value: e.config.connexionId,
                    label: connector?.label
                  }
                : undefined,

              externalId: e.config.externalId,
              status: e.status
            };
          }),
          selectedPlatformAccounts: group.platformAccounts.map(e => {
            const connector = connectorsConnexion.find(
              el => el.value === e.config.connexionId
            );
            const linkConnector = connectorsConnexion.find(
              el => el.value === e.config.linkConnexionId
            );
            return {
              name: e.name,
              model: e.model,
              connexionId: connector
                ? {
                    value: e.config.connexionId,
                    label: connector?.label
                  }
                : undefined,
              externalId: e.config.externalId,
              linkConnexionId: linkConnector
                ? {
                    value: e.config.linkConnexionId,
                    label: linkConnector?.label
                  }
                : undefined,
              linkExternalId: e.config.linkExternalId,
              status: e.status
            };
          }),
          selectedUsers: group.formattedUsers,
          selectedAccountManagers: group.formattedAccountManagers,
          enableCRMCampaign: group.campaignCrm.active,
          crmPresetId: group.campaignCrm.presetId || group.presetId,
          budgetTypeImpressions
        }
      });
      setModal('modalUpdate');
    } else {
      setModal('unauthorized');
    }
  };

  const deleteGroup = id => {
    if (adminRights?.general?.groups?.delete) {
      selectGroup(id);
      setModal('modalDelete');
    } else {
      setModal('unauthorized');
    }
  };

  return (
    <Container>
      <Row spacing={4}>
        <Item xs={3}>
          <TextField
            onChange={e => {
              setPageNumber(0);
              setSearchFieldValue(e);
            }}
            value={searchFieldValue}
            titleHead="Recherche une organisation"
            placeholder="Nom, Key"
            type="search"
            unit={
              <SearchIcon
                style={{
                  color: themeColors.light
                }}
              />
            }
          />
        </Item>
        <Item justify="flex-end" xs>
          <ButtonCreate onClick={addGroup} disabled={!loaded}>
            Ajouter une organisation
          </ButtonCreate>
          {openModal === 'modalCreate' && (
            <ModalForm
              open={openModal === 'modalCreate'}
              onClose={closeModal}
              onNext={handleCreateGroup}
              config={config}
              activableMedias={activableMedias}
            />
          )}
        </Item>
        <Item>
          <Loading loading={!loaded} />
          {loaded && (
            <TableData
              rows={rows}
              headers={[
                { label: 'Nom', id: 'name', sortKey: 'name' },
                { label: 'Funnels', id: 'funnels' },
                { label: 'Preset par défaut', id: 'preset' },
                { label: 'Comptes publicitaires', id: 'platformAccounts' },
                { label: 'Pages publicitaires', id: 'platformPages' },
                {
                  label: 'Liens',
                  id: 'customLabel',
                  help:
                    'client (nom) < organisation (nom) > PML groupements / magasins (key)'
                }
              ]}
              hidenFields={['_id']}
              onUpdate={updateGroup}
              onDelete={deleteGroup}
              pageNumber={pageNumber}
              numberPerRow={rowsPerPage}
              setNumberPerRow={setRowsPerPage}
              totalCount={totalCount}
              getPageNumber={setPageNumber}
              skipSlice
            />
          )}
          {openModal === 'modalUpdate' && (
            <ModalForm
              open={openModal === 'modalUpdate'}
              onClose={closeModal}
              onNext={handleUpdateGroup}
              config={config}
              activableMedias={activableMedias}
            />
          )}
          {openModal === 'modalDelete' && (
            <ModalDelete
              name={selectedGroup.name}
              type="cette organisation"
              open={openModal === 'modalDelete'}
              onClose={closeModal}
              onDelete={onDelete}
            />
          )}
          {openModal === 'unauthorized' && (
            <UnauthorizedModal
              open={openModal === 'unauthorized'}
              onClose={closeModal}
            />
          )}
        </Item>
      </Row>
    </Container>
  );
}

export default GroupContainer;
